(() => { const lang=(document.documentElement.lang||'fr').toLowerCase(); const frFix={ 'Vous aimeriez aussi':'Vous aimerez aussi','Ask AI':'Demander à l’IA','Ask us anything':'Posez votre question','Submit':'Envoyer' }; const en={ 'Accueil':'Home','Nouveautés':'New arrivals','Femme':'Women','Robes':'Dresses','Ensembles':'Sets','Hauts':'Tops','Pantalons & Jupes':'Pants & Skirts','Femmes rondes':'Plus Size','Homme':'Men','Chemises':'Shirts','Pantalons':'Pants','Beauté':'Beauty','Maquillage':'Makeup','Ongles':'Nails','Soins du visage':'Skincare','Corps & Bain':'Body & Bath','Outils beauté':'Beauty Tools','Parfums':'Fragrances','Cheveux':'Hair','Soins capillaires':'Hair Care','Accessoires':'Accessories','Bijoux':'Jewelry','Sacs':'Bags','Chaussures':'Shoes','Hijabs & accessoires':'Hijabs & Accessories','Électronique':'Electronics','Promos':'Deals','Plus':'More','Sur commande':'Made to order','Personnalisation':'Customization','Toutes les collections':'All Collections','Tous les produits':'All Products','Suivre ma commande':'Track My Order','Votre panier':'Your cart','Vous aimerez aussi':'You may also like','Vous aimeriez aussi':'You may also like','Voir tout':'View all','Programme partenaire FatmeyShop':'FatmeyShop partner program','Faire une demande':'Apply','Ask AI':'Ask AI','Posez votre question':'Ask us anything','Envoyer':'Send','Contact':'Contact' }; const map=lang.startsWith('en')?en:frFix; const translate=()=>{ const walker=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT); const nodes=[]; while(walker.nextNode()) nodes.push(walker.currentNode); for(const n of nodes){ const raw=n.nodeValue; const t=raw.trim(); if(map[t]) n.nodeValue=raw.replace(t,map[t]); } document.querySelectorAll('input[placeholder],textarea[placeholder]').forEach(el=>{const p=el.getAttribute('placeholder'); if(map[p]) el.setAttribute('placeholder',map[p]);}); document.querySelectorAll('input[type="submit"],button').forEach(el=>{const v=el.value||el.textContent.trim(); if(map[v]){if(el.value)el.value=map[v];else el.textContent=map[v];}}); }; if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',translate,{once:true}); else translate(); setTimeout(translate,350); setTimeout(translate,1200); })();
(() => {
  const setupFatmeyNavigation = () => {
    const home = document.querySelector('#fatmey-home');
    if (!home) return;

    document.body.classList.add('fm-brand-page');

    const findProductTarget = () => {
      let target =
        document.querySelector('#product-grid') ||
        document.querySelector('.product-grid-container') ||
        document.querySelector('[data-product-grid]') ||
        document.querySelector('.collection-product-grid');

      if (target) {
        const section = target.closest('.shopify-section');
        target = section || target;
      } else {
        const sections = [...document.querySelectorAll('#MainContent > .shopify-section')];
        target = sections.find((section) =>
          section.querySelector('.product-grid, #product-grid, product-grid-component, facet-filters-form, .facets')
        ) || sections[1] || sections[0];
      }

      if (target) target.id = 'fatmey-products';
      return target;
    };

    findProductTarget();

    document.addEventListener('click', (event) => {
      const link = event.target.closest('#fatmey-home a[href]');
      if (!link) return;

      const rawHref = link.getAttribute('href');
      if (!rawHref || rawHref === '#') return;

      if (rawHref.startsWith('#')) {
        if (rawHref === '#fatmey-products') findProductTarget();
        const target = document.querySelector(rawHref);
        if (target) {
          event.preventDefault();
          event.stopImmediatePropagation();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return;
      }

      if (rawHref.startsWith('/') || link.href.startsWith(window.location.origin)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(link.href);
      }
    }, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupFatmeyNavigation, { once: true });
  } else {
    setupFatmeyNavigation();
  }
})();
